<template>
  <footer>
    <MainFooter />
    <SubFooter />
    <ModalContainer />
  </footer>
</template>

<script>
import MainFooter from "./main_footer/MainFooter"
import SubFooter from "./SubFooter"
import ModalContainer from "../modals/ModalContainer"

export default {
  components: {
    MainFooter,
    SubFooter,
    ModalContainer,
  },
}
</script>

<style lang="scss" scoped>
footer {
  background-color: #0e0f12;
  overflow-x: hidden;
  z-index: 2;
  .footer-content-container {
    max-width: 108rem;
    margin: 0 auto;
  }

  /deep/ a {
    text-decoration: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue